import React from 'react';
import {
  Card,
  CardBody,
  Col,
  ModalBody,
  Container,
  Row,
  Modal,
  ModalHeader

} from "reactstrap";
import PropTypes from "prop-types";

const ImageViewer = ({ base64String, documentType, imageViewerModal, onCloseClick, title, closeButtonName }) => {
  const base64FileImage = `data:image/png;base64,${base64String}`;
  const base64FilePdf = `data:application/pdf;base64,${base64String}`
  let isPfdFile = false;
  if (documentType == "pdf") {
    isPfdFile = true;
  }

  const onClick = () => {
    if (onCloseClick) {
      onCloseClick();
    }
  };

  const toggle = () => {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }


  return (
    <Modal
      isOpen={true}
      size="xl"
      backdrop={"static"}
      id="staticBackdrop"
    >
      <ModalHeader tag="h4">
        {title}
      </ModalHeader>
      <ModalBody>
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={10}>
              <Card className="overflow-hidden">
                <CardBody className="pt-1">
                  <br></br>
                  <div className="p-2" style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                    {!isPfdFile && (<img src={base64FileImage} alt="Base64 Image" style={{ maxWidth: '100%', height: 'auto', textAlign: 'center', display: 'flex', justifyContent: 'center' }} />)}
                    {isPfdFile && (<embed src={base64FilePdf} style={{ width: '100%', height: '100vh' }} />)}
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Row>
              <Col lg={12}>
                <div style={{ textAlign: "right" }}>

                  <button
                    type="button"
                    className="btn btn-secondary me-1"
                    onClick={onClick}
                  >
                    {closeButtonName}
                  </button>
                </div>
              </Col>
            </Row>
          </Row>
        </Container>
      </ModalBody>
    </Modal>
  );
};
ImageViewer.propTypes = {
  base64String: PropTypes.string,
  documentType: PropTypes.any,
  className: PropTypes.any,
  imageViewerModal: PropTypes.bool,
  onCloseClick: PropTypes.func,
  closeButtonName: PropTypes.any,
  title: PropTypes.any,
};
export default ImageViewer;
